// extracted by mini-css-extract-plugin
module.exports = {"exercisesCharts":"ProgressBarContainer-module__exercisesCharts___24Lyy"};